export * from "./components/dimmer";
export * from "./dimmer.module";
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ../~/ng2-semantic-ui/dist/modules/dimmer/index.js
// module id = 205
// module chunks = 0